import { Component, OnInit, Input } from '@angular/core';
import { ExportParameters } from 'src/app/models/export/ExportParameters';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { CryptoService } from 'src/app/services/crypto.service';

@Component({
  selector: 'app-export-project-options',
  templateUrl: './export-project-options.component.html',
  styleUrls: ['./export-project-options.component.scss'],
})
export class ExportProjectOptionsComponent implements OnInit {

  @Input() public exportParameters: ExportParameters;
  @Input() public streamingOptionDisabled: boolean;
  @Input() public usageWarningMessages: any;

  constructor(
    public router: Router,
    public modalController: ModalController,
    public cryptoService: CryptoService
  ) { }

  ngOnInit() { }

  streamingChanged(event) {
    if (event.detail.checked === true) {
      this.exportParameters.companionApp = true;
    } else {
      this.exportParameters.companionApp = false;
    }
  }

  buyCredits() {
    this.modalController.dismiss();
    if (this.cryptoService.decryptData(localStorage.getItem("login_r")) == "ad") 
      this.router.navigateByUrl('/my-account');
    else 
      this.router.navigateByUrl('/contact-admin');
  }

}
